module.exports = __webpack_public_path__ + "img/trans-hover.941955eb.svg";